import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-890bf8c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-6 flex flex-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-4 pr-4 border-b border-gray-300" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xl" }, "Adjudication Review")
], -1))
const _hoisted_3 = { class: "container px-10 overflow-scroll" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl font-medium mb-4" }, "Other Comments", -1))
const _hoisted_7 = { class: "bg-gray-100 rounded px-4 py-4" }
const _hoisted_8 = { class: "border-l-4 pl-4 py-2 border-gray-300" }
const _hoisted_9 = { class: "flex space-between w-full py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReviewTable = _resolveComponent("ReviewTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ReviewTable, {
        procedures: _ctx.adjudication.procedures,
        procedureReviews: _ctx.adjudicationReview.procedures,
        class: "px-8 my-8"
      }, null, 8, ["procedures", "procedureReviews"]),
      _hoisted_4,
      (_ctx.adjudicationReview.comments)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.adjudicationReview.comments.split('\n'), (paragraph, i) => {
                  return (_openBlock(), _createElementBlock("p", {
                    class: "comments text-gray-600",
                    key: i
                  }, _toDisplayString(paragraph), 1))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelReview && _ctx.cancelReview(...args))),
          class: "cancel-review button flex-1 font-bold text-white bg-gray-500 px-4 py-2 rounded cursor-pointer",
          type: "button"
        }, " Cancel "),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitReview && _ctx.submitReview(...args))),
          class: "submit-review button flex-1 font-bold text-white bg-blue-500 px-4 py-2 rounded cursor-pointer ml-4",
          type: "button"
        }, " Submit ")
      ])
    ])
  ]))
}